const ApplicationAction = {
    campaignSignIn: "campaignSignIn",
    campaignSignUp: "campaignSignUp",
    linkUp: "linkUp",
    redirectOnly: "redirect",
    childSignUp: "childSignUp",
    childIndependentSignUp: "childIndependentSignUp"
}

export default ApplicationAction; 